import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b04168c0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04168c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b04168c0')) {
      api.createRecord('b04168c0', component.options)
    } else {
      api.reload('b04168c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b04168c0&scoped=true&", function () {
      api.rerender('b04168c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/order/orderManage/index.vue"
export default component.exports